import * as React from 'react';
import {styled} from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({theme}) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 15,
    marginBottom: 15,
    overflow: "hidden",
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{fontSize: '0.8rem'}}/>}
        {...props}
    />
))(({theme}) => ({
    backgroundColor:
        theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function FAQ() {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography sx={{borderLeft: "1px solid #808080", paddingLeft: 2}} fontSize={".9rem"} color="#1a345b"
                                fontWeight={'bold'}>آیا مرکز شما
                        امکان حضور فیزیکی دارد؟</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography fontSize={".9em"}>
                        بله. ما در تمام ساعات کاری پاسخگوی شما در مرکز ول‌بیوتی هستیم.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <Typography sx={{borderLeft: "1px solid #808080", paddingLeft: 2}} fontSize={".8rem"} color="#1a345b"
                                fontWeight={'bold'}>بعد از تهیه
                        اشتراک ویژه چه امکاناتی در اختیار من قرار می‌گیرد؟</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography fontSize={".8rem"}>
                        شما میتوانید از ارزیابی و مشاوره آنلاین با متخصصین ما استفاده کنید.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            {/*<Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>*/}
            {/*    <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">*/}
            {/*        <Typography sx={{borderLeft: "1px solid #808080", paddingLeft: 2}} fontSize={".9rem"} color="#1a345b"*/}
            {/*                    fontWeight={'bold'}>*/}
            {/*            Collapsible*/}
            {/*            Group Item #3*/}
            {/*        </Typography>*/}
            {/*    </AccordionSummary>*/}
            {/*    <AccordionDetails>*/}
            {/*        <Typography>*/}
            {/*            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse*/}
            {/*            malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor*/}
            {/*            sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,*/}
            {/*            sit amet blandit leo lobortis eget.*/}
            {/*        </Typography>*/}
            {/*    </AccordionDetails>*/}
            {/*</Accordion>*/}
        </div>
    );
}